import { Amplify, Auth, Hub } from 'aws-amplify'
import { DataContext } from 'contexts/DataContextContainer'
import { useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import axiosClient, { setAuthHeader } from 'services/axios-client'

function AuthProvider({ children }) {
  const { setLoggedInUser, lang, setLoginError } = useContext(DataContext)
  const history = useHistory()

  useEffect(() => {
    Hub.listen(
      'auth',
      (data) => {
        const { payload } = data
        if (payload.event === 'customOAuthState') {
          // Complete registration after first time using SSO
          const completeOAuthRegistration = async () => {
            const session = await Auth.currentSession()
            const idToken = session.getIdToken()
            const cognitoJWT = session.getAccessToken().getJwtToken()
            const cognitoID = idToken.payload.sub
            let user

            try {
              // If custom state is 'login', then user is logging in. Otherwise, user is completing registration.
              if (payload.data === 'login') {
                const userCheckRes = await axiosClient.get(
                  `/users/cognito/${cognitoID}`,
                )
                if (!userCheckRes.data) {
                  window.location.href = `${process.env.REACT_APP_BASE_URL}/no-book`
                }
              } else {
                user = await axiosClient.put(`/completeInvite`, {
                  hash: payload.data,
                  cognitoToken: cognitoJWT,
                  cognitoID,
                  email: idToken.payload.email,
                  firstName: idToken.payload.given_name,
                  lastName: idToken.payload.family_name,
                  locale: lang,
                })
              }
            } catch (error) {
              console.error(error)
              setLoginError(error)
              return
            }

            const { data } = await axiosClient.post('/user/token', {
              cognitoID,
              cognitoToken: cognitoJWT,
            })
            setAuthHeader(data.token)
            setLoggedInUser(user)
          }
          completeOAuthRegistration()
        }
      },
      'customOAuthState',
    )
  }, [history, setLoggedInUser, lang, setLoginError])

  useEffect(() => {
    Amplify.configure({
      Auth: {
        mandatorySignIn: true,
        region: process.env.REACT_APP_AWS_REGION,
        userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
        userPoolWebClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
        oauth: {
          domain: 'anecdobio.auth.eu-central-1.amazoncognito.com',
          scope: ['email', 'openid', 'profile'],
          redirectSignIn: `${process.env.REACT_APP_BASE_URL}/dashboard`,
          redirectSignOut: process.env.REACT_APP_BASE_URL,
          responseType: 'token',
        },
      },
    })
  }, [])

  return <>{children}</>
}

export default AuthProvider
